import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PreFormGeneric from '../../../common/PreFormGeneric';
import PreFormGoldSilver from '../../../common/PreFormGoldSilver';
import GiftCardBalance from '../../../views/Issues/GiftCards/GiftCardBalance';
import PreFormGiftcardProblems from '../../../common/PreFormGiftcardProblems';
import PreFormRClubes from '../../../common/PreFormRClubes';
import PreFormValidateDni from '../../../common/PreFormValidateDni';
import { INFO_FORGOTTEN_PASSWORD } from '../../../../constants/texts';

const FormList = ({ ...props }) => {
  const { motiveId, issueFormName } = props;
  const { accordeonMotiveOpen } = useSelector(
    (state) => state.breadcrumbsSlice,
  );

  return (
    <React.Fragment>
      {accordeonMotiveOpen === motiveId &&
        '22' !== motiveId &&
        '26' !== motiveId &&
        '27' !== motiveId &&
        '29' !== motiveId &&
        '36' !== motiveId &&
        '38' !== motiveId && (
          <PreFormGeneric motiveId={motiveId} issueFormName={issueFormName} />
        )}
      {'22' === motiveId && (
        <GiftCardBalance motiveId={motiveId} issueFormName={issueFormName} />
      )}
      {'26' === motiveId && (
        <PreFormValidateDni motiveId={motiveId} issueFormName={issueFormName} />
      )}
      {'27' === motiveId && (
        <PreFormValidateDni
          motiveId={motiveId}
          issueFormName={issueFormName}
          messageInfo={INFO_FORGOTTEN_PASSWORD}
          info={true}
        />
      )}
      {'29' === motiveId && (
        <PreFormGoldSilver motiveId={motiveId} issueFormName={issueFormName} />
      )}
      {'36' === motiveId && (
        <PreFormGiftcardProblems
          motiveId={motiveId}
          issueFormName={issueFormName}
        />
      )}
      {'38' === motiveId && (
        <PreFormRClubes motiveId={motiveId} issueFormName={issueFormName} />
      )}
    </React.Fragment>
  );
};

FormList.propTypes = {
  motiveId: PropTypes.string,
  issueFormName: PropTypes.string,
};

export default FormList;
